import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

function CustomerViewPage() {
  const { customerId } = useParams();
  const [customer, setCustomer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const API_BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "https://installmentzone.com/api";

  useEffect(() => {
    const fetchCustomer = async () => {
      try {
        setLoading(true);
        setError(null);

        const response = await fetch(
          `${API_BASE_URL}/customers/show.php?id=${customerId}`
        );
        const result = await response.json();

        if (result.success) {
          setCustomer(result.data);
        } else {
          setError(result.message || "Failed to fetch customer details.");
        }
      } catch (err) {
        console.error("Error fetching customer details:", err);
        setError("An unexpected error occurred.");
      } finally {
        setLoading(false);
      }
    };

    fetchCustomer();
  }, [customerId, API_BASE_URL]);

  if (loading)
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
          color: "#fff",
          fontFamily: "Segoe UI, sans-serif",
          fontSize: "18px",
        }}
      >
        Loading customer details...
      </div>
    );

  if (error)
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
          color: "#fff",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          fontFamily: "Segoe UI, sans-serif",
          padding: "20px",
        }}
      >
        <h2 style={{ color: "#F87171", marginBottom: "10px" }}>
          Error Loading Customer
        </h2>
        <p style={{ textAlign: "center", maxWidth: "400px" }}>{error}</p>
        <button
          onClick={() => window.location.reload()}
          style={{
            marginTop: "15px",
            background: "#1E3A8A",
            color: "#fff",
            border: "none",
            padding: "10px 20px",
            borderRadius: "6px",
            cursor: "pointer",
            fontWeight: "500",
          }}
        >
          Retry
        </button>
      </div>
    );

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #1E3A8A, #3B82F6, #60A5FA)",
        padding: "40px 20px",
        fontFamily: "Segoe UI, sans-serif",
        color: "#fff",
      }}
    >
      <div
        style={{
          background: "rgba(255, 255, 255, 0.15)",
          borderRadius: "15px",
          maxWidth: "700px",
          margin: "0 auto",
          padding: "30px",
          boxShadow: "0 6px 15px rgba(0, 0, 0, 0.2)",
        }}
      >
        <h2
          style={{
            textAlign: "center",
            fontSize: "28px",
            fontWeight: "600",
            marginBottom: "25px",
          }}
        >
          Customer Details
        </h2>

        {customer ? (
          <div
            style={{
              background: "rgba(255, 255, 255, 0.9)",
              color: "#1E293B",
              padding: "25px",
              borderRadius: "10px",
              lineHeight: "1.8",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <p>
              <strong>ID:</strong> {customer.id}
            </p>
            <p>
              <strong>Name:</strong> {customer.first_name} {customer.last_name}
            </p>
            <p>
              <strong>Phone:</strong> {customer.phone_number}
            </p>
            <p>
              <strong>Status:</strong>{" "}
              <span
                style={{
                  color: customer.is_active ? "#16A34A" : "#DC2626",
                  fontWeight: "600",
                }}
              >
                {customer.is_active ? "Active" : "Inactive"}
              </span>
            </p>
            <p>
              <strong>Email:</strong> {customer.email || "N/A"}
            </p>
            <p>
              <strong>Created At:</strong>{" "}
              {new Date(customer.created_at).toLocaleString()}
            </p>
          </div>
        ) : (
          <p style={{ textAlign: "center" }}>No customer data available.</p>
        )}
      </div>
    </div>
  );
}

export default CustomerViewPage;
